import { useEffect, useRef, useState } from 'react';
import { GetBranchOffices } from '../network/Branch';
import { useAuth } from '../../components/customContextProviders/AuthContext';
import { APP_CONSTANTS } from '../../URLConstants';
import { parseValidationErrorMessage } from '../../utils/Utilities';


export function useBranches() {
    const { fetchRegionList, fetchTaxonomyDetails, sessionUserData, fetchZonesList, fetchHeadOfficesList } = useAuth()
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [searchBy, setSearchBy] = useState('name');
    const [branchModalOpen, setBranchModalOpen] = useState(false)
    const [branchesListData, setbranchesListData] = useState({
        loading: false,
        data: [],
        metas: {}
    });

    const [selectedBranchForAction, setSelectedBranchForAction] = useState({
        branch: {},
        action: null
    })

    const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
    const [snackBarMetas, setSnackBarMetas] = useState({
        title: '',
        message: '',
        severity: 'info',
        handleClose: null
    });



    const handleChangePage = (data, customPage) => {
        const where = {
            ...(searchText ? { [searchBy]: searchBy === 'branchId' ? searchText?.toUpperCase() : searchText } : {}),
        }
        let newPage = page;
        if (data === 'NEXT') newPage += 1;
        else newPage -= 1;

        if (customPage) {
            setPage(customPage);
            fetchbranches(customPage, where);
            return;
        }
        setPage(newPage);
        fetchbranches(newPage, where);
    };

    const fetchbranches = (targetPage = 1, where = {}) => {
        setbranchesListData((prev) => ({
            ...prev,
            loading: true
        }))
        GetBranchOffices(targetPage, 10, where)
            .then((response) => {
                setbranchesListData((prev) => ({
                    ...prev,
                    data: response?.data?.data,
                    metas: response?.data,
                    loading: false
                }))

            })
            .catch(() => {
                setbranchesListData([]);
                setbranchesListData((prev) => ({
                    ...prev,
                    loading: false
                }))
            })
    };

    useEffect(() => {
        fetchbranches(page);
        fetchRegionList()
    }, []);


    const handleSearch = (value, field = searchBy) => {
        setSearchText(value);
        const where = {
            ...(value ? { [field]: field === 'branchId' ? value?.toUpperCase() : value } : {})
        }
        fetchbranches(1, where);
    };

    const handleSearchByChange = (field) => {
        setSearchBy(field);
        setSearchText('');
    };


    const handleBranchMoreMenuClick = (action, branchData) => {
        switch (action) {
            case 'update_branch': {
                fetchTaxonomyDetails(sessionUserData?.user?.taxonomyId);
                setBranchModalOpen(true);
                fetchZonesList();
                fetchHeadOfficesList();
                setSelectedBranchForAction({
                    branch: branchData,
                    action: 'update_branch'
                });

                break;
            }
            default: {
                return '';
            }
        }
    };

    function onUpdateBranchAction(action, msg) {
        const where = {
            ...(searchText ? { [searchBy]: searchBy === 'branchId' ? searchText?.toUpperCase() : searchText } : {})
        }
        if (action === APP_CONSTANTS?.BRANCH_UPDATE_SUCCESSFULL) {
            const currentPage = 1;
            setPage(currentPage)
            fetchbranches(currentPage, where);

            setSnackBarMetas((prevState) => ({
                ...prevState,
                title: msg,
                severity: 'success'
            }));
            setIsSnackBarAlertOpen(true);
        } else if (action === APP_CONSTANTS?.BRANCH_UPDATE_UNSUCCESSFULL) {
            setSnackBarMetas((prevState) => ({
                ...prevState,
                title: parseValidationErrorMessage(msg),
                severity: 'error'
            }));
            setIsSnackBarAlertOpen(true);
        } else if (action === APP_CONSTANTS?.NO_CHANGES) {
            setSnackBarMetas((prevState) => ({
                ...prevState,
                title: msg,
                severity: 'info'
            }));
            setIsSnackBarAlertOpen(true);
        }
    }

    return {
        page,
        searchText,
        setSearchText,
        searchBy,
        handleSearchByChange,
        branchesListData,

        handleChangePage,
        handleSearch,
        fetchbranches,
        setPage,
        isSnackBarAlertOpen,
        setSnackBarMetas,
        setIsSnackBarAlertOpen,
        snackBarMetas,

        onUpdateBranchAction,
        handleBranchMoreMenuClick,
        branchModalOpen,
        setBranchModalOpen,
        selectedBranchForAction,
        setSelectedBranchForAction
    };
}